
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'SocialLinks',
    data(){ 
        return {
            audio: '' as any,
            imgLoaded: false,
            currentlyPlaying: false,
            currentlyStopped: false,
            currentTime: 0,
            checkingCurrentPositionInTrack: "",
            trackDuration: 0,
            currentProgressBar: 0,
            isPlaylistActive: false,
            currentSong: 0,
            debug: false,
            hollerPlaylist: [
                {
                    title: "Holler",
                    artist: "TAUR",
                    url: "/album/03 Holler.mp3",
                    image: "/album/holler-cover-lodef.jpg"
                },
            ],
            basePlaylist: [
                {
                    title: "The Man That You Were",
                    artist: "TAUR",
                    url: "/album/01 The Man That You Were.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Half Somewhere",
                    artist: "TAUR",
                    url: "/album/02 Half Somewhere.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Holler",
                    artist: "TAUR",
                    url: "/album/03 Holler.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Strong",
                    artist: "TAUR",
                    url: "/album/04 Strong.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Materials",
                    artist: "TAUR",
                    url: "/album/05 Materials.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "The Constant",
                    artist: "TAUR",
                    url: "/album/06 The Constant.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Stay",
                    artist: "TAUR",
                    url: "/album/07 Stay.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Chicago",
                    artist: "TAUR",
                    url: "/album/08 Chicago.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Holysayer",
                    artist: "TAUR",
                    url: "/album/09 Holysayer.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Cowards",
                    artist: "TAUR",
                    url: "/album/10 Cowards.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "My Hideaway",
                    artist: "TAUR",
                    url: "/album/11 My Hideaway.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Lay Back",
                    artist: "TAUR",
                    url: "/album/12 Lay Back.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Midnight",
                    artist: "TAUR",
                    url: "/album/13 Midnight.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "Wastin",
                    artist: "TAUR",
                    url: "/album/14 Wastin.mp3",
                    image: "/album/cover.jpg"
                },
                {
                    title: "The Only Thing I Trust",
                    artist: "TAUR",
                    url: "/album/15 The Only Thing I Trust.mp3",
                    image: "/album/cover.jpg"
                },
            ],
            audioFile: ""
        }
    },
	mounted: function() {
		this.changeSong()
		this.audio.loop = false;
    },
    props: {
        isHoller: {
            type: Boolean,
            default: false,
        },
        isSmall: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        musicPlaylist(): any {
            if (this.isHoller) {
                return this.hollerPlaylist
            } else {
                return this.basePlaylist
            }
        }
    },
	methods: {
        getFancyTimeFormat(s: any) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s
        },
		togglePlaylist: function() {
			this.isPlaylistActive = !this.isPlaylistActive;
		},
		nextSong: function() {
			if (this.currentSong < this.musicPlaylist.length - 1)
				this.changeSong(this.currentSong + 1);
		},
		prevSong: function() {
			if (this.currentSong > 0) this.changeSong(this.currentSong - 1);
		},
		changeSong: function(index?: number) {
			var wasPlaying = this.currentlyPlaying;
			this.imgLoaded = false;
			if (index !== undefined) {
				this.stopAudio();
				this.currentSong = index;
			}
			this.audioFile = this.musicPlaylist[this.currentSong].url;
			this.audio = new Audio(this.audioFile);
			var localThis = this;
			this.audio.addEventListener("loadedmetadata", function(event: any) {
				localThis.trackDuration = Math.round(event.target.duration);
			});
			this.audio.addEventListener("ended", this.handleEnded);
			if (wasPlaying) {
				this.playAudio();
			}
		},
		isCurrentSong: function(index: any) {
			if (this.currentSong == index) {
				return true;
			}
			return false;
		},
		getCurrentSong: function(currentSong: any) {
			return this.musicPlaylist[currentSong].url;
		},
		playAudio: function() {
			if (
				this.currentlyStopped == true &&
				this.currentSong + 1 == this.musicPlaylist.length
			) {
				this.currentSong = 0;
				this.changeSong();
			}
			if (!this.currentlyPlaying) {
				this.getCurrentTimeEverySecond();
				this.currentlyPlaying = true;
				this.audio.play();
			} else {
				this.stopAudio();
			}
			this.currentlyStopped = false;
		},
		stopAudio: function() {
			this.audio.pause();
			this.currentlyPlaying = false;
			this.pausedMusic();
		},
		handleEnded: function() {
			if (this.currentSong + 1 == this.musicPlaylist.length) {
				this.stopAudio();
				this.currentlyPlaying = false;
				this.currentlyStopped = true;
			} else {
				this.currentlyPlaying = false;
				this.currentSong++;
				this.changeSong();
				this.playAudio();
			}
		},
		onImageLoaded: function() {
			this.imgLoaded = true;
		},
		getCurrentTimeEverySecond: function() {
			var localThis = this;
			this.checkingCurrentPositionInTrack = setTimeout(
				function() {
					localThis.currentTime = localThis.audio.currentTime;
					localThis.currentProgressBar =
						localThis.audio.currentTime / localThis.trackDuration * 100;
					localThis.getCurrentTimeEverySecond();
				}.bind(this),
				1000
			) as any;
		},
		pausedMusic: function() {
			clearTimeout(this.checkingCurrentPositionInTrack as any);
		},
		toggleDebug: function(){
			this.debug=!this.debug;
			document.body.classList.toggle('debug');
		}
	},
	watch: {
		currentTime: function() {
			this.currentTime = Math.round(this.currentTime);
		}
	},
	beforeUnmount: function() {
		this.audio.removeEventListener("ended", this.handleEnded);
		this.audio.removeEventListener("loadedmetadata", this.handleEnded);

		clearTimeout(this.checkingCurrentPositionInTrack as any);
	}
})
